module.exports = __webpack_public_path__ + "img/KR.0c21189d.gif";